export enum ConnectToDonorMilestone {
    PendingContact = 0,
    Contacted = 1,
    WorkupSurvey = 2,
    PreOpSurvey = 3,
    PostDonation3DaysSurvey = 4,
    PostDonation30DaysSurvey = 5,
    CompletedAllSurveys = 6
}